import { Log } from '../../AuxillaryService/Log';
import { startLoop, stopLoop } from './ExecutionLoop';
import { Priority } from './Miscellaneous';

/** @type Object.<number, ActionQueueItem[]>  */
const ActionQueueItems = {};
ActionQueueItems[Priority.BACKGROUND] = [];
ActionQueueItems[Priority.LOW] = [];
ActionQueueItems[Priority.NORMAL] = [];
ActionQueueItems[Priority.HIGH] = [];
ActionQueueItems[Priority.CRITICAL] = [];
ActionQueueItems[Priority.OVERRIDE] = [];

/** @type Object.<number, number>  */
const ActionQueueWeights = {};
ActionQueueWeights[Priority.BACKGROUND] = 0;
ActionQueueWeights[Priority.LOW] = 0;
ActionQueueWeights[Priority.NORMAL] = 0;
ActionQueueWeights[Priority.HIGH] = 0;
ActionQueueWeights[Priority.CRITICAL] = 0;
ActionQueueWeights[Priority.OVERRIDE] = 0;

/**
 * @class
 */
function ActionQueueItem() {
    this.m_priority = Priority.NORMAL;
    this.m_complexity = 100;
    this.m_weight = 100;
    this.m_callback = null;
    this.m_arguments = [];
    this.m_name = 'action';

    /**
     * @returns {ActionQueueItem}
     */
    this.Named = function (name) {
        this.m_name = name;
        return this;
    };

    /**
     * defines the priority of this action. Actions with higher priority
     * are executed before items with low priority.
     *
     * default: `Priority.NORMAL`
     * @returns {ActionQueueItem}
     */
    this.WithPriority = function (priority) {
        this.m_priority = priority;
        return this;
    };

    /**
     * defines the "weight" of an action. Actions with a higher weight are
     * more likely to be executed before those with low weight in the same
     * priority level
     *
     * default: `100`
     */
    this.Weighs = function (weight) {
        this.m_weight = weight;
        return this;
    };

    /**
     * defines the complexity (average JS statements per action call).
     * ActionQueue uses this to determine if it should begin execution
     * of the action or give control back to the browser
     *
     * default: `100`
     * @returns {ActionQueueItem}
     */
    this.HasComplexity = function (complexity) {
        this.m_complexity = complexity;
        return this;
    };

    /**
     * defines the callback to execute when the action is executed
     * @returns {ActionQueueItem}
     */
    this.OnExecuteCall = function (method) {
        this.m_callback = method;

        for (var i = 1; i < arguments.length; ++i) {
            this.m_arguments.push(arguments[i]);
        }

        return this;
    };

    /**
     * this action queue item is configured and ready to be added to
     * the queue.
     * @returns {ActionQueueItem}
     */
    this.Commit = function () {
        ActionQueueItems[this.m_priority].push(this);
        ActionQueueWeights[this.m_priority] += this.m_weight;
        startLoop();
        return this;
    };
}

const ActionQueue = {};

ActionQueue.Log = function (message) {
    if (typeof Log != 'undefined') {
        Log.Info(message);
    }
};

ActionQueue.New = function () {
    return new ActionQueueItem();
};

ActionQueue.debug = function () {
    console.debug('ActionQueue items: ', ActionQueueItems);
    ActionQueue.Log('ActionQueue items: ' + ActionQueueItems);
};

ActionQueue.Execute = function () {
    var c_sum = 0;
    for (var level = 5; level >= 0; level--) {
        if (ActionQueueItems[level].length > 0) {
            var sel = Math.floor(Math.random() * ActionQueueWeights[level]);
            for (var i = 0; i < ActionQueueItems[level].length; ++i) {
                var item = ActionQueueItems[level][i];

                sel -= item.m_weight;

                if (sel <= 0) {
                    try {
                        //execute this one
                        item.m_callback.apply(item.m_callback, item.m_arguments);
                    } catch (e) {
                        ActionQueue.Log('exception during ActionQueue.Execute: ' + e);
                    }

                    //remove from the queue
                    ActionQueueItems[level].splice(i, 1);

                    //start over with this level
                    i = -1;

                    //deduct this item's weight from the total weight for this
                    //level
                    ActionQueueWeights[level] -= item.m_weight;

                    //get the new total weight for this level
                    sel = Math.floor(Math.random() * ActionQueueWeights[level]);

                    c_sum += item.m_complexity;

                    //see if we've exceeded our complexity
                    if (c_sum >= 2000) {
                        return true;
                    }
                }
            }
        }
    }

    stopLoop();
    return false;
};

export { ActionQueue, ActionQueueItems, ActionQueueWeights };
